module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-one-quarter  cfholder"
  }, [_c('clientfilter')], 1), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "columns is-multiline is-gapless is-mobile clientcontainer",
    on: {
      "mouseleave": _vm.boxOff
    }
  }, _vm._l((this.clients), function(client, index) {
    return _c('div', {
      staticClass: "column is-narrow"
    }, [_c('div', {
      staticClass: "client",
      class: {
        dev: client.dev, seo: client.seo, code: client.code, design: client.design, agency: client.agency
      },
      on: {
        "mouseover": _vm.boxHover,
        "click": _vm.boxClick
      }
    }, [_c('img', {
      attrs: {
        "src": './static/clients/' + client.logo,
        "alt": client.name
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "details"
    }, [_c('b', [_vm._v(_vm._s(client.name))]), _c('br'), _vm._v(_vm._s(client.description))])])])
  }))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-63ffa832!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Client.vue
// module id = 111
// module chunks = 2